/**
* Utility functions
*/
import Vue from 'vue';
import * as VueGoogleMaps from './vendor/vue-google-maps/main';
var win = window;
var $ = win.jQuery;
/**
 * Smooth scroll
 */
export function scrollTo(target, speed, margin, onComplete) {
    if (speed === void 0) { speed = 500; }
    if (margin === void 0) { margin = 0; }
    if (onComplete === void 0) { onComplete = function () { }; }
    $('html, body').animate({
        scrollTop: $(target).offset().top - margin
    }, speed, 'swing', onComplete);
}
/**
 * Focus and scroll
 */
export function focusAndScroll(el, container) {
    setTimeout(function () {
        el.focus();
        scrollTo(el);
        $(container).animate({
            scrollTop: $(el).offset().top,
        }, 150, 'swing');
    }, 50);
}
/**
 * A link with [data-toggle] that toggles a simple class
 */
export function toggleLinks() {
    $(document).on('click', '[data-toggle]', function (e) {
        var $this = $(e.currentTarget);
        var target = $this.attr('data-toggle-target') || 'body';
        var $target = $(target);
        var cls = $this.attr('data-toggle');
        if ($this.is('[data-toggle-remove]'))
            $target.removeClass(cls);
        else if ($this.is('[data-toggle-add]'))
            $target.addClass(cls);
        else
            $target.toggleClass(cls);
    });
}
/**
 * Same as toggleLinks, but with aria-expanded
 */
export function toggleExpandedLinks() {
    $(document).on('click', '[data-toggle-expanded]', function (e) {
        var $this = $(e.currentTarget);
        var target = $this.attr('data-toggle-expanded') || 'body';
        var $target = $(target);
        var isExpanded = $target.attr('aria-expanded') === 'true';
        if (isExpanded)
            $target.attr('aria-expanded', 'false');
        else
            $target.attr('aria-expanded', 'true');
    });
}
/**
 * Blur when a focused item is clicked
 */
export function blurOnClick() {
    $(document).on('mousedown', '[data-blur-on-click]', function (e) {
        var $this = $(e.currentTarget);
        if ($this.is(':focus'))
            $this.blur();
    });
}
/**
 * Automatically toggle aria-expanded
 */
export function toggleAriaExpanded() {
    $(document).on('click', '[aria-expanded]', function (e) {
        var $item = $(e.currentTarget);
        var isExpanded = ($item.attr('aria-expanded') === 'true');
        $item.attr('aria-expanded', !isExpanded ? 'true' : 'false');
    });
}
/**
 * A link with [data-focus] that toggles a simple class
 */
export function focusLinks() {
    $(document).on('click', '[data-focus]', function (e) {
        var $this = $(e.currentTarget);
        var target = $this.attr('data-focus');
        var $target = $(target);
        var wait = $this.attr('data-wait') || 200;
        setTimeout(function () { $target[0].focus(); }, wait);
    });
}
/**
 * Smooth scroll-to links
 *
 * @param selector
 * @param topMargin
 * @param defaultSpeed
 */
export function scrollToLinks(selector, topMargin, defaultSpeed) {
    if (selector === void 0) { selector = '.scroll-to, [data-scroll-to]'; }
    if (topMargin === void 0) { topMargin = 0; }
    if (defaultSpeed === void 0) { defaultSpeed = 1000; }
    $(document).on('click', selector, function (e) {
        var $this = $(e.currentTarget);
        var href = $this.attr('href');
        if (href) {
            e.preventDefault();
            var $target = $(href);
            var speed = $(e.currentTarget).attr('data-scroll-to') || defaultSpeed;
            var margin = $this.is('[data-scroll-to-margin]') ? $this.attr('data-scroll-to-margin') : topMargin;
            scrollTo($target, speed, margin);
        }
    });
}
/**
 * Toggle class, depending on whether the "val" parameter is true or not
 *
 * @param val
 * @param cls
 * @param [targetSelector]
 */
export function toggleClassByVal(val, cls, targetSelector) {
    if (targetSelector === void 0) { targetSelector = 'body'; }
    var $target = $(targetSelector);
    if (val)
        $target.addClass(cls);
    else
        $target.removeClass(cls);
}
/**
 * Get the mobile size from the stylesheet
 *
 * @returns {boolean}
 */
export function isMobile(defaultSize) {
    if (defaultSize === void 0) { defaultSize = 750; }
    var link = $('link[rel="stylesheet"][media*="max-width"][href*="mobile.css"]');
    var size = link.length ? parseInt(link.attr('media').match(/(\d+)/)[0]) : defaultSize;
    return $(window).width() <= size;
}
/**
 * Get whether the page is RTL, by examining the HTML's "dir" attribute
 */
export function isRTL() {
    return $('html').attr('dir') == 'rtl';
}
/**
 * Automatic full-height elements
 *
 * @param selector
 */
export function fullHeight(selector) {
    if (selector === void 0) { selector = '[data-full-height]'; }
    var $el = $(selector);
    var resize = function () { return $(selector).each(function (index, item) {
        var property = $el.attr('data-full-height');
        var headerHeight = $el.attr('data-full-height-header') ?
            $($el.attr('data-full-height-header')).height() :
            0;
        var margin = (property == 'max-height') ?
            $el.attr('data-full-height-margin') || headerHeight :
            0;
        $(item).css(property, $(window).height() - margin);
    }); };
    $(window).on('load resize', function () { return resize(); });
    resize();
}
/**
 * Replace form buttons with links, for styling
 */
export function styledButtons() {
    var style = function () {
        $('form input[type="submit"]').each(function (i, button) {
            if (!$(button).is('.is-styled')) {
                var classes = $(button).attr('class');
                var title = $(button).attr('value');
                var html = "<a class=\"button button--replacement " + classes + "\" href=\"javascript:void(0)\">" + title + "</a>";
                var $link = $(html).insertAfter(button);
                $link.on('click', function () {
                    $(button).trigger('click');
                });
                $(button).hide();
                $(button).addClass('is-styled');
            }
        });
    };
    style();
    $(document).on('gform_post_render', function () { return style(); });
}
/**
 * Infinite posts
 */
export function loadMore() {
    var $container = $('[data-load-more-container]');
    // Mark the containers that don't have more items as already loaded
    $container.each(function (i, item) {
        if ($(item).children().length < $(item).data('items-per-page')) {
            $(item).addClass('is-already-loaded');
        }
    });
    // When the load more button is clicked
    $(document).on('click', '[data-load-more]', function (e) { return loadMore(e); });
    var loadMore = function (e) {
        var $container = $('[data-load-more-container]');
        var offset = $container.data('offset');
        var postsPerPage = $container.data('items-per-page');
        var nextOffset = parseInt(offset, 10) + parseInt(postsPerPage, 10);
        $container.addClass('is-loading');
        $.get(window.location.href, { 'ajax': true, 'offset': nextOffset }, function (data) {
            var $items = $(data);
            console.log(data);
            if (data) {
                $container.append($items);
                console.log(nextOffset);
                $container.attr('data-offset', nextOffset);
            }
            $container.removeClass('is-loading');
            if (!data.trim() || $items.length < postsPerPage) {
                $container.addClass('is-all-loaded');
            }
        });
    };
}
/**
 * Slideshow accessibility: a pause/resume button button on slideshows, and focus adjustments
 */
export function slideshowA11y() {
    // Pause resume
    $(document).on('click', '.a11y-pause--cycle2', function (e) {
        var $this = $(e.currentTarget);
        var $slideshow = $this.parents('.slideshow');
        if ($this.is('.a11y-pause--play')) {
            $this.removeClass('a11y-pause--play');
            $slideshow.cycle('resume');
            $(window).trigger('screen-reader-notify', $this.data('play-message'));
            $this.attr('title', $this.find('.pause-label').text());
        }
        else {
            $this.addClass('a11y-pause--play');
            $slideshow.cycle('pause');
            $(window).trigger('screen-reader-notify', $this.data('pause-message'));
            $this.attr('title', $this.find('.play-label').text());
        }
    });
    // Focus to the slide whenever we select a pager item
    $(document).on('click', '.pager__item', function (e) {
        var index = $(e.currentTarget).attr('data-index');
        var slideTitle = $(".slideshow__slide[data-index=\"" + index + "\"] .title--slideshow");
        setTimeout(function () { return slideTitle.focus(); }, 500);
    });
    // Keyboard nav for cycle2
    $(document).on('keyup', '.cycle-slideshow', function (e) {
        var $target = $(e.currentTarget);
        if (e.keyCode === 37)
            $target.cycle('prev');
        else if (e.keyCode === 39)
            $target.cycle('next');
        if (e.keyCode === 37 || e.keyCode === 39)
            e.stopPropagation();
    });
}
/**
 * Get the current section, by getting the element in the middle of the screen
 *
 * @param selector
 * @returns {*}
 */
export function getCurrentSectionFromPoint(selector) {
    if (selector === void 0) { selector = '.section'; }
    var centerElement = document.elementFromPoint($(window).width() / 2, $(window).height() / 2);
    var $centerElement = $(centerElement);
    if ($centerElement.is(selector))
        return $centerElement;
    else {
        var parent_1 = $centerElement.parents().filter(selector);
        if (parent_1.length)
            return parent_1;
        else
            return null;
    }
}
/**
 * Wrap-around value, when it doesn't fall within (min, max]
 *
 * @param val
 * @param min
 * @param max
 * @return Number
 */
export function wraparound(val, min, max) {
    if (val < min)
        return max - 1;
    else if (val >= max)
        return min;
    else
        return val;
}
/**
 * Find if two elements are overlapping
 */
export function isOverlapping($el1, $el2) {
    var getPos = function ($el) {
        return {
            left: $el.offset().left,
            top: $el.offset().top,
            bottom: $el.offset().top + $el.outerHeight(true),
            right: $el.offset().left + $el.outerWidth(true),
            height: $el.outerHeight(true),
            width: $el.outerWidth(true),
        };
    };
    var el1 = getPos($el1);
    var el2 = getPos($el2);
    return el1.bottom >= el2.top && el1.top <= el2.bottom &&
        el2.right >= el1.left && el1.left <= el2.right;
}
/**
 * Get the current section from calculating the exact position relative to the scrollPosition
 *
 * @param selector
 * @returns {*}
 */
export function getCurrentSectionFromSectionPos(selector, centerMargin) {
    if (selector === void 0) { selector = '.section'; }
    if (centerMargin === void 0) { centerMargin = 0; }
    var centerPoint = $(window).scrollTop() + ($(window).height() / 2) + centerMargin;
    var $sections = $(selector);
    var currentItem = null;
    $sections.each(function () {
        var $section = $(this);
        var top = $section.offset().top;
        var bottom = top + $section.outerHeight(true);
        if ((centerPoint > top) && (bottom > centerPoint)) {
            currentItem = $section;
        }
    });
    return currentItem;
}
/**
 * Play/pause videos on click
 */
export function toggleVideoPlay() {
    $(document).on('click', 'video', function () {
        var video = $(this)[0];
        if (video.paused && video.readyState == 4)
            video.play();
        else
            video.pause();
    });
}
/**
 * Mark the header when it's scrolling down, so we can give
 * it another appearance, make it position: fixed and so on
 *
 * @param margin
 * @param headerSelector
 * @param downClass
 */
export function markScrolledDown(margin, headerSelector, downClass) {
    if (margin === void 0) { margin = 50; }
    if (headerSelector === void 0) { headerSelector = '.header'; }
    if (downClass === void 0) { downClass = 'is-down'; }
    var getMargin = typeof margin == 'function' ? margin : function () { return margin; };
    var $header = $(headerSelector);
    var mark = function () {
        if ($(window).scrollTop() > getMargin()) {
            $header.addClass(downClass);
        }
        else {
            $header.removeClass(downClass);
        }
    };
    $(window).on('scroll load', mark);
    mark();
}
/**
 * Remove the hash from the location, without triggering a refresh
 */
export function removeHash() {
    history.pushState("", document.title, window.location.pathname + window.location.search);
}
/**
 * Marks the current section
 *
 * @param options
 */
export function markCurrentSection(options) {
    var defaults = {
        onCurrentSection: function (section) { },
        getCurrentSection: getCurrentSectionFromSectionPos,
        refreshRate: 150,
        selector: '.section',
        linksSelector: 'a.section-link',
        currentClass: 'is-current-section',
        sectionAttr: 'data-section',
        bodyAttr: 'data-current-section'
    };
    var _a = $.extend({}, defaults, options), onCurrentSection = _a.onCurrentSection, getCurrentSection = _a.getCurrentSection, refreshRate = _a.refreshRate, selector = _a.selector, linksSelector = _a.linksSelector, currentClass = _a.currentClass, sectionAttr = _a.sectionAttr, bodyAttr = _a.bodyAttr;
    var $sections = $(selector);
    var $links = $(linksSelector);
    // Throttle the onScroll, for performance
    var isScrolling = false;
    var $previousSection = $('');
    var onScroll = function () { isScrolling = true; };
    var doScroll = function () {
        if (isScrolling) {
            var $currentSection = getCurrentSection(selector);
            // Callback when change
            var currentId = $currentSection ? $currentSection.attr('id') : NaN; // Use NaN because NaN != NaN
            var previousId = $previousSection ? $previousSection.attr('id') : NaN;
            if (currentId != previousId) {
                onCurrentSection($currentSection);
                $previousSection = $currentSection;
            }
            if ($currentSection && $currentSection.length) {
                var $currentLink = $(linksSelector).filter('[href="#' + currentId + '"]');
                $(linksSelector).removeClass(currentClass);
                $currentLink.addClass(currentClass);
                $sections.removeClass(currentClass);
                $currentSection.addClass(currentClass);
                $('body').attr(bodyAttr, $currentSection.attr(sectionAttr));
            }
            isScrolling = false;
        }
    };
    setInterval(doScroll, refreshRate);
    doScroll();
    $(window).on('scroll load resize', onScroll);
}
/**
 * Add a class to empty form elements, for styling
 *
 * @param selector
 */
export function markEmptyInputs(selector) {
    if (selector === void 0) { selector = 'input, select, textarea'; }
    var mark = function () {
        $(selector).each(function () {
            if (!$(this).val())
                $(this).addClass('is-empty');
            else
                $(this).removeClass('is-empty');
        });
    };
    mark();
    $(document).on('change keyup', selector, mark);
}
/**
 * Mark the input's container with an is-focused class when it's in focus,
 * so we can properly style the focused mode. Especially useful for Ninja Forms 3
 *
 * @param selector
 * @param parent
 */
export function markFocusedInputContainer(selector, parent) {
    if (selector === void 0) { selector = '.submit-wrap input[type="button"]'; }
    if (parent === void 0) { parent = '.submit-wrap'; }
    $(document).on('focus', selector, function (e) {
        $(e.currentTarget).parents(parent).addClass('is-focused');
    });
    $(document).on('blur', selector, function (e) {
        $(e.currentTarget).parents(parent).removeClass('is-focused');
    });
}
/**
 * Mark items that are in the viewport. Relies on the jquery.viewport plugin
 *
 * @param itemSelector
 */
export function markItemsInViewport(itemSelector) {
    $(itemSelector).each(function (i, item) {
        if ($(item).is(':in-viewport'))
            $(item).addClass('in-viewport');
        else
            $(item).removeClass('in-viewport');
    });
}
/**
 * Add a class to the body when scrolling to the bottom,
 * so we can do stuff like hide the social menu
 */
export function markWhenAtBottomOfPage(margin, footerSelector) {
    if (margin === void 0) { margin = 0; }
    if (footerSelector === void 0) { footerSelector = '.footer'; }
    var $body = $('body');
    var $footer = $(footerSelector);
    var mark = function () {
        var scrollDelta = $(document).height() - $(window).scrollTop() - $(window).height();
        if (scrollDelta <= (margin + $footer.height()))
            $body.addClass('is-at-bottom');
        else
            $body.removeClass('is-at-bottom');
    };
    mark();
    $(window).on('scroll resize', function () { return mark(); });
}
/**
 * Equalize the heights of the direct children of a container,
 * to create multi-column layouts, where table-cell layouts are still buggy (like in iPads)
 */
export function equalHeightColumns(selector, childSelector) {
    if (selector === void 0) { selector = '.equal-height-columns'; }
    if (childSelector === void 0) { childSelector = '> *'; }
    var resize = function () {
        $(selector).each(function (i, item) {
            var $children = $(item).find(childSelector);
            $children.height('auto');
            var maxHeight = 0;
            $children.each(function (j, child) {
                var height = $(child).height();
                if (height > maxHeight)
                    maxHeight = height;
            });
            $children.height(maxHeight);
        });
    };
    $(window).on('load resize', function () { return resize(); });
}
/**
 * Implements the in-fields-labels functionality for a given selector: that is, hides the label when it's clicked
 * or when the textbox is focused, shows it when it isn't and has no value
 */
export function inFieldLabels(formWrapper, labelSelector) {
    if (formWrapper === void 0) { formWrapper = '.gfield'; }
    if (labelSelector === void 0) { labelSelector = 'label'; }
    var init = function () {
        var inputSelector = 'input, textarea';
        $(formWrapper).each(function () {
            var $control = $(this).find(inputSelector);
            var $label = $(this).find(labelSelector);
            // If the input has text in it, hide the label
            if ($control.val())
                $label.addClass('is-hidden');
            // If the label is clicked, hide the label
            $label.on('click', function () {
                $(this).addClass('is-hidden');
            });
            $control // Hide or show the label according to focus
                .focus(function () {
                $(this).parents(formWrapper).find('label').addClass('is-hidden');
            })
                .blur(function () {
                if (!$(this).val())
                    $(this).parents(formWrapper).find('label').removeClass('is-hidden');
            });
        });
    };
    init();
    $(window).on('gform_post_render', function () { return init(); });
}
/**
 * Add a "screen-reader-notify" event to the window,
 * that allows us to voice messages, for a11y purposes
 */
export function screenReaderNotifications() {
    var $notification = $('.screen-reader-notification');
    if (!$notification.length) {
        $notification = $("<div class=\"screen-reader-notification visuallyhidden\" aria-live=\"assertive\"></div>").prependTo('body');
    }
    var notify = function (message) { $notification.attr('role', 'alert').html(message); };
    $(window).on('screen-reader-notify', function (e, message) { notify(message); });
    // Notify on GForms errors, since Firefox doesn't seem to register them
    var onGForm = function () {
        if ($('#error').length)
            notify($('#error').text());
        if ($('.gform_confirmation_message').length)
            notify($('.gform_confirmation_message').text());
    };
    $(document).on('gform_post_render', function () { return onGForm(); });
    $(window).on('load', function () { return onGForm(); });
}
/**
 * VH fix for iOS, based on tips from https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 */
export function fixVH() {
    var setVH = function () {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + "px");
    };
    setVH();
    $(window).on('load resize', function () { return setVH(); });
}
/**
 * The vue components are wrapper with a .vue div.
 * Go over each of them, and init it
 */
export function initVues(components) {
    if (!win.vueInstances) {
        win.vueInstances = [];
    }
    $('.vue').each(function (i, item) {
        if (!$(item).attr('vue-loaded')) {
            $(item).attr('vue-loaded', true);
            var vue = new Vue({
                el: item,
                components: components
            });
            win.vueInstances.push(vue);
        }
    });
}
/**
 * Main menu toggle button, including a11y adjustments for keyboard etc.
 */
export function mainMenu() {
    function setFocus(item) {
        setTimeout(function () {
            if ($(item).length)
                $(item)[0].focus();
        }, 250);
    }
    var $body = $('body');
    var classes = 'is-menu-open is-booking-open';
    $(document).on('click', '.menu-toggle', function () {
        $body.removeClass('is-booking-open');
        if ($body.is('.is-menu-open')) {
            $body.removeClass('is-menu-open');
            setFocus('#content');
        }
        else {
            $body.addClass('is-menu-open');
            setFocus('.menu--main');
        }
    });
    $(document).on('click', '.book-button', function () {
        $body.removeClass('is-menu-open');
    });
    $(window).on('keyup', function (e) {
        if (e.keyCode === 27) {
            $body.removeClass(classes);
            setFocus('#content');
        }
    });
    $(document).on('click', '.content', function (e) {
        $body.removeClass('is-menu-open');
    });
    // Hover and click on "location"
    $('.header a[href*="location"]')
        .hover(function () { return $body.addClass('is-location-shown'); }, function () { return $body.removeClass('is-location-shown'); });
}
/**
 * Initialize the Vue Google Maps component
 */
export function initGoogleMaps() {
    Vue.use(VueGoogleMaps, {
        load: {
            key: win.siteOptions.googleMapsApiKey,
            libraries: 'places',
            installComponents: false,
            language: 'en',
        },
    });
}
